<template>
    <div class="cnt">
        <p>{{ round.title }} kreće za:</p>
        <div>
            <span> {{ values.leftValue }} </span>
            <small>{{ values.leftDesc }}</small>
        </div>
        <div>
            <span> {{ values.rightValue }} </span>
            <small>{{ values.rightDesc }}</small>
        </div>
    </div>
</template>

<script>
import { DDHHMMSSCounterValues } from '../utils/timeUtils'

export default {
    name: 'until-next-round-counter',
    computed: {
        round () {
            return this.$store.state.round
        },
        counters () {
            return this.$store.state.counters
        },
        values () {
            return DDHHMMSSCounterValues(this.counters)
        }
    }
}
</script>

<style lang="scss" scoped>
.counter {
    div.cnt {
    box-shadow: 0px 18px 24px 0px rgba(0,0,0,0.34);
    padding: 16px 14px 14px;
    background-color: #001840;
    color: #fff;
    border-radius: 10px;
    height: 100%;
    vertical-align: baseline;
    display: inline-block;
        div {
            float: left;
            max-width: 49%;
        }
    }
    p {
        margin: 0;
    }
    span {
        font-size: 25px;
        display: inline-block;
        margin: 5px 0 2px;
        min-width: 56px;
    }
    small {
        font-family: "axiforma";
        text-transform: uppercase;
        font-size: 10px;
        letter-spacing: 1px;
        color: #85c0f8;
        margin-right: 6px;
    }
}
</style>
